import { combineReducers } from 'redux';

import item from './item';
import condition from './condition';
import moreButton from './moreButton';

export default combineReducers({
    condition: condition,
    item:item,
    moreButton: moreButton
})
